export class LogoutAction {
  static type = '[AUTH] Logout';
}
